var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse, _path41, _ellipse2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotPic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 227,
    viewBox: "0 0 187 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6233 135.163C74.402 132.24 59.9277 114.384 65.7754 89.9377C65.7754 89.9377 73.7403 83.17 97.6899 88.8988C121.639 94.6276 125.68 104.267 125.68 104.267C119.832 128.714 98.8445 138.087 86.6233 135.163Z",
    fill: "url(#paint0_linear_3506_261688)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.39 103.523C122.382 103.506 122.372 103.484 122.358 103.455C122.323 103.385 122.27 103.281 122.192 103.146C122.037 102.876 121.789 102.481 121.416 101.989C120.669 101.004 119.423 99.6279 117.429 98.0712C113.442 94.9581 106.461 91.1225 94.5 88.2613C82.5386 85.4001 74.5779 85.6617 69.6133 86.6335C67.131 87.1194 65.397 87.7831 64.2857 88.3233C63.73 88.5935 63.3299 88.8329 63.0696 89.0039C62.9394 89.0894 62.8443 89.1579 62.7821 89.2045C62.7568 89.2235 62.737 89.2389 62.7225 89.2503C56.9137 113.62 71.3495 131.385 83.49 134.289C95.6304 137.193 116.543 127.884 122.39 103.523Z",
    fill: "url(#paint1_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1224 134.715C102.03 133.713 117.238 124.025 122.258 104.061C119.416 107.683 115.155 109.193 110.953 110.238C109.977 110.481 109.003 110.699 108.05 110.912C107.932 110.939 107.815 110.965 107.698 110.991C106.632 111.23 105.596 111.466 104.614 111.728C102.647 112.253 100.907 112.881 99.5826 113.836C93.725 118.061 91.366 123.31 90.4699 127.502C90.0216 129.598 89.9394 131.431 89.9692 132.739C89.9841 133.393 90.027 133.915 90.0661 134.274C90.0856 134.453 90.1042 134.591 90.1178 134.684C90.1194 134.695 90.1209 134.705 90.1224 134.715Z",
    fill: "url(#paint2_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3825 131.668C67.2172 125.386 58.0396 109.864 62.5967 89.7906C63.4923 94.3059 66.6089 97.581 69.8826 100.414C70.643 101.072 71.4132 101.708 72.1668 102.329C72.2598 102.406 72.3526 102.482 72.4451 102.559C73.2871 103.254 74.104 103.933 74.8613 104.611C76.3776 105.969 77.6459 107.317 78.3944 108.768C81.7059 115.187 81.4346 120.934 80.3368 125.078C79.7877 127.151 79.0317 128.822 78.4133 129.975C78.1041 130.551 77.8295 130.998 77.6324 131.3C77.5339 131.451 77.4548 131.566 77.4006 131.642C77.3942 131.651 77.3881 131.66 77.3825 131.668Z",
    fill: "url(#paint3_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7294 89.2511C62.6183 89.7753 62.7756 90.3588 63.1826 90.9942C63.5997 91.6455 64.2708 92.3378 65.148 93.0534C66.9017 94.4842 69.4568 95.9902 72.3778 97.4324C78.2188 100.316 85.4983 102.933 90.6926 104.176C95.8869 105.418 103.563 106.379 110.076 106.45C113.334 106.486 116.294 106.299 118.505 105.816C119.611 105.575 120.523 105.262 121.19 104.87C121.84 104.487 122.244 104.038 122.383 103.52C122.375 103.504 122.364 103.481 122.35 103.453C122.316 103.383 122.262 103.279 122.185 103.144C122.03 102.874 121.782 102.479 121.409 101.987C120.662 101.002 119.417 99.6261 117.423 98.0696C113.437 94.9567 106.458 91.1215 94.4994 88.261C82.5408 85.4004 74.5818 85.6624 69.6182 86.6345C67.1364 87.1205 65.4027 87.7842 64.2917 88.3245C63.7361 88.5947 63.336 88.8341 63.0758 89.0052C62.9457 89.0907 62.8505 89.1592 62.7883 89.2058C62.7723 89.2179 62.7584 89.2285 62.7467 89.2376C62.7403 89.2425 62.7345 89.2471 62.7294 89.2511Z",
    fill: "url(#paint4_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.268 97.1852C81.3444 94.5722 71.0796 89.1412 71.7445 86.3619C71.7445 86.3619 80.4422 84.9476 94.3968 88.2856C108.351 91.6236 115.055 96.4638 115.055 96.4638C114.391 99.243 103.192 99.7982 92.268 97.1852Z",
    fill: "#667FE1",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7806 103.979C80.5101 101.522 61.9907 93.7282 63.0531 89.2864C63.0531 89.2864 62.2518 95.1724 91.2291 102.104C120.206 109.035 122.155 103.424 122.155 103.424C121.093 107.865 101.051 106.435 90.7806 103.979Z",
    fill: "url(#paint5_linear_3506_261688)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8519 104.885C82.5272 105.457 85.1904 105.454 85.52 104.489C85.52 104.489 84.8942 103.662 81.6483 102.553C78.4024 101.445 77.4011 101.717 77.4011 101.717C77.0828 102.649 79.1766 104.313 80.8519 104.885Z",
    fill: "url(#paint6_linear_3506_261688)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2606 117.913C67.9096 115.06 65.2986 111.325 64.9878 111.472C64.677 111.619 65.827 115.63 67.4329 118.897C69.0388 122.163 71.2596 125.327 71.4849 125.22C71.7102 125.114 70.6117 120.766 69.2606 117.913Z",
    fill: "url(#paint7_linear_3506_261688)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.476 46.0167C154.976 41.3412 162.776 37.4444 170.622 40.9209C179.469 44.8407 175.063 57.2538 171.371 63.8357C172.913 65.8201 173.38 66.919 173.38 66.919C159.936 97.2593 124.021 103.355 97.4538 91.583C70.8868 79.8112 51.2749 49.1117 64.7186 18.7714C64.7186 18.7714 65.8422 18.3806 68.3384 18.1894C70.7603 11.0249 76.9775 -0.440514 85.7791 3.45946C93.5793 6.91573 95.9511 15.2345 96.2058 22.4212C103.726 24.6254 112.78 27.887 123.561 32.664C134.315 37.4294 142.799 41.9348 149.476 46.0167Z",
    fill: "url(#paint8_linear_3506_261688)",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5832 19.3705L91.8447 31.45C92.7098 28.5683 93.5016 22.688 92.5561 16.8221C91.5962 10.8668 88.8514 4.95407 82.6065 2.187C80.1395 1.09385 77.8843 1.22455 75.8598 2.13141C73.8304 3.04042 72.0265 4.7325 70.4782 6.77142C67.413 10.808 65.375 16.1706 64.5832 19.3705Z",
    fill: "url(#paint9_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8786 18.9338C68.4915 14.1643 74.6296 11.2375 83.0548 14.9707C87.1902 16.8031 90.4703 19.1739 93.0558 21.8196L89.5004 29.8436L64.8786 18.9338Z",
    fill: "url(#paint10_linear_3506_261688)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.828 64.543L139.566 52.4635C141.12 49.8869 144.944 45.3502 149.924 42.11C154.981 38.8204 161.204 36.8817 167.449 39.6487C169.916 40.7419 171.334 42.5002 172.023 44.6091C172.713 46.723 172.671 49.196 172.201 51.7126C171.27 56.6948 168.666 61.8069 166.828 64.543Z",
    fill: "url(#paint11_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.081 64.0874C168.187 58.2071 166.232 51.6941 157.807 47.961C153.671 46.1286 149.711 45.2915 146.015 45.1536L142.459 53.1776L167.081 64.0874Z",
    fill: "url(#paint12_linear_3506_261688)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.123 65.5361C170.11 65.5084 170.091 65.4686 170.065 65.4169C170.009 65.3045 169.921 65.1361 169.792 64.9143C169.535 64.4706 169.119 63.8132 168.484 62.9631C167.213 61.263 165.064 58.7919 161.557 55.7182C154.544 49.5705 142.1 41.0129 120.388 31.3919C98.6746 21.771 83.9762 18.3021 74.711 17.2368C70.0785 16.7042 66.8046 16.7725 64.6913 16.973C63.6346 17.0733 62.8681 17.2066 62.367 17.3145C62.1164 17.3684 61.9322 17.416 61.8112 17.4498C61.7555 17.4654 61.7132 17.4781 61.6841 17.4871C48.3198 47.73 67.8663 78.3406 94.3793 90.0885C120.892 101.836 156.698 95.7521 170.123 65.5361Z",
    fill: "url(#paint13_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.594 17.3881C61.594 17.3881 63.6595 17.0707 65.2893 16.8711C59.402 28.3966 53.6399 50.99 74.3017 76.3638C59.3979 61.3434 51.8971 39.2723 61.594 17.3881Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.076 46.4865C149.034 46.4511 148.973 46.4003 148.889 46.3338C148.706 46.1886 148.417 45.9685 147.996 45.6711C147.154 45.0763 145.782 44.1725 143.668 42.9399C139.441 40.4745 132.248 36.6944 120.391 31.4405C108.534 26.1866 100.899 23.3965 96.2305 21.9201C93.8962 21.1819 92.3039 20.7722 91.2963 20.5473C90.7926 20.4348 90.4351 20.3685 90.2043 20.3304C90.0982 20.3129 90.0189 20.3013 89.9644 20.294C89.8839 20.5587 89.9305 20.9206 90.1301 21.3829C90.3498 21.8916 90.7452 22.4989 91.3098 23.1874C92.4381 24.5634 94.2268 26.245 96.5821 28.0844C101.292 31.7625 108.252 36.0608 116.688 39.7985C125.123 43.5362 132.991 45.7783 138.883 46.7822C141.829 47.2843 144.276 47.4759 146.051 47.3917C146.939 47.3496 147.652 47.2386 148.173 47.0662C148.645 46.9101 148.939 46.7107 149.076 46.4865Z",
    fill: "url(#paint14_linear_3506_261688)",
    stroke: "#A2A5D5",
    strokeWidth: 0.243312
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 48.0529C166.542 58.5053 169.466 65.4537 169.466 65.4537C159.17 88.6901 135.646 97.5821 113.447 95.0243C125.015 88.7445 148.716 70.5585 150.979 48.0529Z",
    fill: "url(#paint15_linear_3506_261688)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4337 85.4508C76.7997 76.7511 63.2674 59.0191 67.2193 40.427C68.154 36.0296 71.8432 32.9532 76.3377 33.0558C83.1449 33.2113 95.3812 35.1949 114.875 43.8324C134.368 52.4699 144.058 60.2015 148.746 65.1396C151.841 68.4 152.042 73.2012 149.401 76.8396C138.321 92.106 116.048 94.1421 96.4337 85.4508Z",
    fill: "url(#paint16_linear_3506_261688)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9884 35.6496C85.541 35.9623 97.0216 38.0526 115.072 46.0505C130.142 52.7282 139.086 58.7801 144.324 63.299C139.137 60.102 126.71 54.6585 119.77 61.6237C103.17 78.2852 88.5597 75.4971 83.0324 73.048C79.7272 71.5834 77.5621 68.6754 77.3544 68.3884C71.9732 60.7886 68.7001 51.8161 69.9075 43.0877C70.5365 38.54 74.4026 35.4307 78.9884 35.6496Z",
    fill: "url(#paint17_linear_3506_261688)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.943 48.1942C115.504 49.3291 119.454 50.2553 119.815 49.4419C119.815 49.4419 118.776 48.4273 113.814 46.2285C108.851 44.0296 107.402 43.9419 107.402 43.9419C107.054 44.7278 110.381 47.0593 112.943 48.1942Z",
    fill: "url(#paint18_linear_3506_261688)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1905 29.8463C66.9387 26.7792 66.5685 22.0643 65.9204 21.9062C65.2723 21.7481 63.7241 25.3423 62.9623 28.9027C62.2005 32.4632 62.1653 36.7512 62.6351 36.8658C63.1049 36.9804 65.4422 32.9134 66.1905 29.8463Z",
    fill: "url(#paint19_linear_3506_261688)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.17 75.5603C154.047 77.8974 152.12 82.2165 152.614 82.665C153.108 83.1135 156.185 80.6954 158.555 77.9313C160.925 75.1672 163.004 71.4168 162.646 71.0917C162.288 70.7666 158.292 73.2232 156.17 75.5603Z",
    fill: "url(#paint20_linear_3506_261688)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.128 75.1078C145.162 76.147 144.544 78.3307 144.886 78.649C145.229 78.9674 146.745 78.0085 147.805 76.761C148.866 75.5135 149.64 73.6709 149.392 73.4401C149.144 73.2094 147.094 74.0687 146.128 75.1078Z",
    fill: "url(#paint21_linear_3506_261688)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.732 32.9246C110.657 28.9036 104.037 25.2856 104.195 24.9283C104.195 24.9283 107.597 25.8965 120.343 31.5445C133.09 37.1924 136.086 39.0588 136.086 39.0588C135.934 39.4017 128.806 36.9457 119.732 32.9246Z",
    fill: "url(#paint22_linear_3506_261688)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.193 61.5576C109.965 61.863 109.747 62.1798 109.54 62.5078L110.311 62.9946C110.216 63.1465 110.122 63.301 110.032 63.4581C109.941 63.6151 109.854 63.7732 109.77 63.9321L108.963 63.507C108.782 63.8501 108.617 64.1973 108.466 64.5475L109.304 64.9076C109.161 65.241 109.033 65.5772 108.918 65.9155L108.054 65.6236C107.93 65.9902 107.822 66.3592 107.73 66.7295L108.615 66.9506C108.527 67.3017 108.454 67.6541 108.396 68.0067L107.496 67.8585C107.433 68.2398 107.387 68.6215 107.356 69.0026L108.265 69.0762C108.236 69.4359 108.222 69.7948 108.223 70.1521L107.31 70.1541C107.311 70.54 107.328 70.9242 107.361 71.3055L108.27 71.227C108.301 71.5856 108.347 71.9414 108.408 72.2934L107.509 72.4488C107.575 72.8286 107.656 73.2044 107.754 73.5751L108.636 73.3428C108.728 73.6896 108.834 74.0314 108.955 74.367L108.096 74.6758C108.226 75.0379 108.372 75.3937 108.534 75.7418L109.362 75.3576C109.512 75.6814 109.677 75.9979 109.855 76.3061L109.066 76.7641C109.259 77.0962 109.467 77.4196 109.69 77.733L110.434 77.2038C110.64 77.493 110.859 77.7729 111.092 78.0424L110.402 78.6393C110.653 78.9288 110.918 79.2074 111.197 79.4739L111.827 78.814C112.082 79.0578 112.351 79.2907 112.632 79.5117L112.068 80.2289C112.367 80.4647 112.681 80.6879 113.007 80.8974L113.5 80.1297C113.649 80.2254 113.801 80.318 113.956 80.4075C114.111 80.497 114.267 80.5823 114.424 80.6634L114.006 81.4742C114.35 81.6521 114.7 81.8117 115.054 81.9536L115.393 81.1066C115.725 81.2396 116.061 81.3555 116.4 81.4549L116.143 82.3305C116.513 82.4391 116.887 82.5293 117.263 82.6016L117.435 81.7055C117.785 81.7728 118.137 81.8232 118.491 81.857L118.404 82.7653C118.787 82.802 119.171 82.8206 119.555 82.8216L119.557 81.9092C119.914 81.9101 120.27 81.8946 120.626 81.863L120.706 82.7718C121.089 82.7378 121.47 82.6866 121.849 82.6184L121.687 81.7204C122.038 81.6572 122.387 81.5784 122.733 81.4841L122.973 82.3645C123.343 82.2638 123.709 82.1468 124.071 82.0138L123.756 81.1574C124.091 81.0342 124.423 80.8963 124.749 80.7439L125.135 81.5705C125.482 81.4084 125.823 81.2312 126.158 81.0391L125.704 80.2478C126.013 80.0699 126.317 79.8784 126.614 79.6734L127.133 80.4243C127.447 80.2071 127.754 79.9759 128.053 79.731L127.475 79.0253C127.751 78.7987 128.02 78.5596 128.281 78.3082L128.914 78.9644C129.189 78.6992 129.455 78.4212 129.71 78.1308L129.025 77.5279C129.261 77.2599 129.488 76.9805 129.706 76.6899L130.436 77.2361C130.665 76.9308 130.883 76.614 131.09 76.2859L130.318 75.7991C130.414 75.6472 130.507 75.4927 130.598 75.3356C130.688 75.1786 130.776 75.0205 130.859 74.8616L131.667 75.2867C131.847 74.9436 132.013 74.5964 132.163 74.2462L131.325 73.8861C131.468 73.5527 131.597 73.2165 131.711 72.8782L132.575 73.1701C132.699 72.8035 132.807 72.4346 132.9 72.0642L132.014 71.8431C132.102 71.492 132.175 71.1396 132.233 70.787L133.133 70.9352C133.196 70.5539 133.243 70.1722 133.274 69.7912L132.364 69.7175C132.393 69.3578 132.407 68.9989 132.406 68.6416L133.319 68.6396C133.318 68.2537 133.301 67.8696 133.268 67.4882L132.359 67.5667C132.328 67.2081 132.282 66.8523 132.221 66.5004L133.12 66.3449C133.055 65.9651 132.973 65.5893 132.875 65.2186L131.993 65.4509C131.902 65.1041 131.795 64.7623 131.675 64.4267L132.533 64.118C132.403 63.7558 132.257 63.4 132.095 63.0519L131.268 63.4361C131.117 63.1123 130.953 62.7958 130.774 62.4877L131.563 62.0297C131.37 61.6975 131.162 61.3741 130.939 61.0607L130.196 61.5899C129.99 61.3007 129.77 61.0208 129.537 60.7513L130.227 60.1544C129.977 59.8649 129.712 59.5863 129.432 59.3198L128.802 59.9797C128.547 59.7359 128.279 59.503 127.998 59.282L128.562 58.5648C128.262 58.329 127.949 58.1058 127.623 57.8963L127.129 58.664C126.98 58.5683 126.829 58.4757 126.674 58.3862C126.519 58.2968 126.363 58.2115 126.205 58.1303L126.624 57.3195C126.279 57.1417 125.929 56.982 125.575 56.8401L125.236 57.6871C124.904 57.5542 124.568 57.4382 124.23 57.3388L124.486 56.4632C124.116 56.3546 123.742 56.2644 123.366 56.1921L123.194 57.0882C122.844 57.0209 122.492 56.9705 122.139 56.9367L122.226 56.0284C121.843 55.9918 121.458 55.9731 121.074 55.9721L121.072 56.8845C120.716 56.8836 120.359 56.8991 120.004 56.9307L119.923 56.0219C119.541 56.0559 119.159 56.1071 118.781 56.1753L118.942 57.0733C118.591 57.1365 118.242 57.2153 117.896 57.3096L117.656 56.4292C117.287 56.5299 116.92 56.6469 116.558 56.7799L116.873 57.6363C116.538 57.7595 116.207 57.8974 115.881 58.0498L115.494 57.2232C115.147 57.3853 114.806 57.5625 114.472 57.7546L114.926 58.5459C114.616 58.7238 114.312 58.9154 114.015 59.1203L113.497 58.3694C113.182 58.5866 112.875 58.8178 112.576 59.0627L113.154 59.7685C112.878 59.995 112.609 60.2341 112.349 60.4855L111.715 59.8293C111.44 60.0945 111.175 60.3725 110.919 60.6629L111.604 61.2658C111.368 61.5338 111.141 61.8132 110.924 62.1038L110.193 61.5576Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.82484,
    strokeDasharray: "1.22 1.22"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1884 45.3588C79.9763 45.7038 79.7779 46.0623 79.5947 46.4337L80.4129 46.8374C80.329 47.0075 80.2485 47.1805 80.1715 47.3564C80.0944 47.5323 80.022 47.7088 79.9539 47.8858L79.1022 47.5585C78.9537 47.9451 78.8248 48.334 78.7153 48.7239L79.5937 48.9707C79.4896 49.3413 79.4042 49.7125 79.3372 50.0829L78.4393 49.9204C78.3657 50.3272 78.3125 50.7335 78.2792 51.1377L79.1885 51.2126C79.1571 51.5944 79.1448 51.9738 79.1511 52.3492L78.2388 52.3646C78.2458 52.7774 78.2736 53.1862 78.3216 53.5892L79.2277 53.4812C79.2728 53.8596 79.3371 54.2319 79.4201 54.5965L78.5305 54.799C78.622 55.2012 78.7345 55.5954 78.8674 55.9795L79.7297 55.6813C79.8533 56.0384 79.9957 56.3853 80.1564 56.7204L79.3336 57.1148C79.5115 57.4859 79.7102 57.8444 79.9289 58.1883L80.6988 57.6985C80.8992 58.0135 81.1177 58.3143 81.3534 58.599L80.6507 59.181C80.9119 59.4963 81.1929 59.7946 81.493 60.0735L82.1142 59.4052C82.3836 59.6555 82.6696 59.8883 82.9719 60.1018L82.4455 60.8471C82.7772 61.0814 83.1268 61.295 83.4935 61.4858L83.9146 60.6764C84.0772 60.7609 84.2435 60.8406 84.4136 60.915C84.5837 60.9895 84.7551 61.0577 84.9274 61.1197L84.6184 61.9782C85.0074 62.1183 85.4014 62.2302 85.7986 62.315L85.9891 61.4227C86.351 61.4999 86.7161 61.5522 87.0828 61.5803L87.0131 62.4901C87.4216 62.5213 87.8314 62.5255 88.2403 62.5035L88.1912 61.5924C88.5603 61.5725 88.9295 61.529 89.2968 61.4626L89.4592 62.3604C89.8602 62.2879 90.2584 62.1907 90.6518 62.0697L90.3835 61.1976C90.7386 61.0883 91.0902 60.9576 91.4364 60.8062L91.8022 61.6421C92.1746 61.4791 92.5405 61.2944 92.8981 61.0888L92.4434 60.2978C92.7676 60.1114 93.0848 59.9062 93.3934 59.6826L93.9287 60.4216C94.2574 60.1835 94.5766 59.9266 94.8846 59.6518L94.277 58.971C94.5572 58.721 94.8276 58.4546 95.0868 58.1725L95.7587 58.7898C96.0331 58.4912 96.2955 58.1764 96.5445 57.8464L95.816 57.297C96.0427 56.9964 96.2576 56.6819 96.4592 56.3541L97.2364 56.832C97.4485 56.487 97.6469 56.1285 97.8301 55.7572L97.0119 55.3534C97.0958 55.1834 97.1764 55.0104 97.2534 54.8345C97.3304 54.6585 97.4029 54.482 97.4709 54.305L98.3226 54.6323C98.4711 54.2458 98.6 53.8569 98.7095 53.4669L97.8311 53.2201C97.9353 52.8496 98.0206 52.4784 98.0876 52.1079L98.9855 52.2704C99.0591 51.8637 99.1123 51.4574 99.1456 51.0531L98.2363 50.9782C98.2677 50.5965 98.28 50.2171 98.2737 49.8416L99.186 49.8262C99.179 49.4135 99.1512 49.0047 99.1032 48.6017L98.1972 48.7097C98.1521 48.3313 98.0877 47.959 98.0047 47.5944L98.8944 47.3919C98.8028 46.9897 98.6903 46.5955 98.5574 46.2113L97.6951 46.5096C97.5716 46.1525 97.4291 45.8055 97.2685 45.4705L98.0912 45.076C97.9133 44.7049 97.7146 44.3464 97.4959 44.0026L96.726 44.4923C96.5256 44.1773 96.3072 43.8766 96.0714 43.5919L96.7741 43.0099C96.5129 42.6945 96.2319 42.3963 95.9318 42.1173L95.3106 42.7857C95.0413 42.5353 94.7552 42.3025 94.4529 42.0891L94.9793 41.3438C94.6476 41.1095 94.298 40.8959 93.9313 40.7051L93.5102 41.5145C93.3477 41.4299 93.1813 41.3503 93.0112 41.2758C92.8411 41.2013 92.6697 41.1331 92.4974 41.0711L92.8064 40.2126C92.4175 40.0726 92.0234 39.9607 91.6262 39.8759L91.4357 40.7682C91.0738 40.6909 90.7087 40.6386 90.3421 40.6105L90.4117 39.7008C90.0032 39.6695 89.5935 39.6654 89.1846 39.6874L89.2336 40.5985C88.8645 40.6183 88.4954 40.6618 88.128 40.7283L87.9656 39.8304C87.5646 39.903 87.1664 40.0002 86.773 40.1212L87.0413 40.9933C86.6862 41.1025 86.3346 41.2332 85.9884 41.3847L85.6227 40.5488C85.2502 40.7118 84.8843 40.8965 84.5267 41.102L84.9814 41.8931C84.6572 42.0794 84.34 42.2847 84.0314 42.5082L83.4961 41.7693C83.1674 42.0074 82.8482 42.2642 82.5402 42.5391L83.1478 43.2198C82.8676 43.4699 82.5972 43.7363 82.338 44.0183L81.6661 43.401C81.3917 43.6997 81.1293 44.0144 80.8804 44.3444L81.6088 44.8939C81.3821 45.1945 81.1673 45.5089 80.9657 45.8368L80.1884 45.3588Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.82484,
    strokeDasharray: "1.22 1.22"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5808 90.5358C62.5808 90.5358 63.2987 93.06 64.2516 94.4813C61.6547 102.998 64.3932 124.883 81.1548 133.408C66.2208 126.944 58.5618 109.383 62.5808 90.5358Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.668 110.898C114.409 113.988 115.82 116.63 116.747 116.586C117.674 116.542 118.095 116.084 119.56 112.487C121.026 108.89 121.207 108.41 120.413 107.589C119.618 106.767 116.927 107.808 115.668 110.898Z",
    fill: "url(#paint23_linear_3506_261688)",
    fillOpacity: 0.4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M113.905 113.284C110.68 119.242 110.03 124.556 111.055 124.042C112.081 123.528 116.828 117.56 118.778 113.764C120.729 109.967 121.189 108.561 120.433 107.617C119.678 106.674 117.129 107.326 113.905 113.284Z",
    fill: "url(#paint24_linear_3506_261688)",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6127 130.878C98.2858 128.781 117.191 119.243 116.647 115.174C116.102 111.104 96.0146 110.962 80.6229 113.47C65.2311 115.978 48.9363 117.912 49.6852 123.504C50.4341 129.095 66.9396 132.975 82.6127 130.878Z",
    fill: "url(#paint25_linear_3506_261688)",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.767 127.415C99.4401 125.318 118.345 115.78 117.801 111.711C117.257 107.641 97.1689 107.499 81.7772 110.007C66.3854 112.515 50.0906 114.449 50.8395 120.041C51.5883 125.632 68.0939 129.512 83.767 127.415Z",
    fill: "url(#paint26_linear_3506_261688)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8466 109.697C66.4946 112.142 50.2539 114.1 50.9063 118.971C50.9063 118.971 51.3717 115.122 81.3162 111.034C115.895 106.314 117.289 110.946 117.289 110.946C116.815 107.401 97.1985 107.252 81.8466 109.697Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7692 127.416C68.0961 129.513 51.5906 125.633 50.8417 120.042C50.7284 119.196 51.0052 118.434 51.6099 117.74C51.6099 117.74 58.5122 120.706 73.3781 122.51C93.5571 124.959 101.063 122.759 102.573 122.196C102.673 122.155 102.774 122.114 102.873 122.073C102.873 122.073 102.779 122.119 102.573 122.196C96.7448 124.571 90.0015 126.582 83.7692 127.416Z",
    fill: "url(#paint27_linear_3506_261688)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5508 115.008C83.1942 114.575 88.2264 112.672 88.1574 112.091C88.0884 111.51 83.5677 111.47 79.3781 112.059C75.1885 112.648 70.4728 114.075 70.5228 114.497C70.5729 114.918 75.9073 115.44 79.5508 115.008Z",
    fill: "url(#paint28_linear_3506_261688)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5914 99.0026C65.3161 102.328 62.8623 104.045 62.0557 103.587C61.2491 103.128 61.0811 102.529 61.4019 98.6581C61.7227 94.7872 61.778 94.2778 62.8581 93.9045C63.9382 93.5312 65.8667 95.6775 65.5914 99.0026Z",
    fill: "url(#paint29_linear_3506_261688)",
    fillOpacity: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0853 101.928C66.2649 108.7 64.4404 113.733 63.7585 112.811C63.0766 111.888 61.5437 104.419 61.5224 100.15C61.5011 95.8821 61.7274 94.4197 62.8277 93.9203C63.9279 93.4208 65.9058 95.1557 66.0853 101.928Z",
    fill: "url(#paint30_linear_3506_261688)",
    fillOpacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1642 77.4394C39.4009 90.2741 56.7235 102.452 60.0559 100.054C63.3884 97.6558 54.0457 79.8724 44.5793 67.4796C35.1128 55.0868 25.7265 41.6272 21.148 44.9232C16.5695 48.2191 20.9276 64.6048 30.1642 77.4394Z",
    fill: "url(#paint31_linear_3506_261688)",
    fillOpacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7639 76.8261C43.0005 89.6608 60.3231 101.839 63.6555 99.4406C66.988 97.0425 57.6453 79.2592 48.1789 66.8663C38.7125 54.4735 29.3261 41.014 24.7476 44.3099C20.1691 47.6058 24.5272 63.9915 33.7639 76.8261Z",
    fill: "url(#paint32_linear_3506_261688)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.485 66.78C39.093 54.3925 29.7106 40.9921 25.7222 43.8633C25.7222 43.8633 29.3369 42.4593 47.0557 66.9424C67.5165 95.2145 64.0886 98.627 64.0886 98.627C66.9915 96.538 57.877 79.1674 48.485 66.78Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7652 76.8262C24.5285 63.9916 20.1704 47.6059 24.7489 44.3099C25.4416 43.8113 26.2442 43.6962 27.1406 43.9028C27.1406 43.9028 27.7786 51.3879 33.1943 65.3494C40.5454 84.3007 46.023 89.8835 47.2313 90.9502C47.3147 91.0194 47.3981 91.0884 47.4814 91.1571C47.4814 91.1571 47.396 91.0956 47.2313 90.9502C42.3894 86.9295 37.438 81.9298 33.7652 76.8262Z",
    fill: "url(#paint33_linear_3506_261688)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7194 67.2562C44.818 70.2658 48.868 73.8072 49.3483 73.4723C49.8285 73.1374 47.733 69.1315 45.2389 65.714C42.7448 62.2966 39.263 58.8105 38.9149 59.0532C38.5668 59.2959 40.6208 64.2467 42.7194 67.2562Z",
    fill: "url(#paint34_linear_3506_261688)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3677,
    cy: 13.4652,
    rx: 37.3677,
    ry: 13.4652,
    transform: "matrix(-1 -6.25916e-10 -6.25916e-10 1 121.268 142.024)",
    fill: "url(#paint35_radial_3506_261688)",
    fillOpacity: 0.4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M131.279 6.80957L120.559 31.0041",
    stroke: "url(#paint36_linear_3506_261688)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.56926,
    cy: 5.39037,
    rx: 5.56926,
    ry: 5.39037,
    transform: "matrix(-0.914268 -0.40511 -0.40511 0.914268 138.68 4.19336)",
    fill: "url(#paint37_linear_3506_261688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3506_261688",
    x1: 62.8145,
    y1: 102.316,
    x2: 127.1,
    y2: 117.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3506_261688",
    x1: 121.399,
    y1: 108.19,
    x2: 61.4947,
    y2: 93.8602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3506_261688",
    x1: 119.543,
    y1: 115.95,
    x2: 94.3907,
    y2: 118.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3506_261688",
    x1: 59.6384,
    y1: 101.62,
    x2: 80.8955,
    y2: 115.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3506_261688",
    x1: 121.392,
    y1: 108.188,
    x2: 61.501,
    y2: 93.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#E9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3506_261688",
    x1: 92.1133,
    y1: 101.616,
    x2: 91.5319,
    y2: 104.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336756,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3506_261688",
    x1: 81.6483,
    y1: 102.553,
    x2: 80.8519,
    y2: 104.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#CCD7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3506_261688",
    x1: 67.9534,
    y1: 118.532,
    x2: 69.2097,
    y2: 118.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3506_261688",
    x1: 60.2056,
    y1: 28.9565,
    x2: 176.813,
    y2: 80.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3506_261688",
    x1: 78.0838,
    y1: 32.7942,
    x2: 80.9059,
    y2: 1.30038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3506_261688",
    x1: 62.2233,
    y1: 17.7572,
    x2: 93.2585,
    y2: 21.3621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3506_261688",
    x1: 147.815,
    y1: 63.5601,
    x2: 169.248,
    y2: 40.3129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3506_261688",
    x1: 169.736,
    y1: 65.264,
    x2: 146.217,
    y2: 44.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3506_261688",
    x1: 167.684,
    y1: 71.342,
    x2: 59.0222,
    y2: 23.1944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3506_261688",
    x1: 148.808,
    y1: 47.403,
    x2: 89.4774,
    y2: 21.1138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#BCBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#BBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#97B1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91C5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3506_261688",
    x1: 152.243,
    y1: 86.5329,
    x2: 139.821,
    y2: 71.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3506_261688",
    x1: 143.366,
    y1: 83.0962,
    x2: 69.1597,
    y2: 34.2918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470359,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3506_261688",
    x1: 114.735,
    y1: 66.4983,
    x2: 72.5168,
    y2: 35.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3506_261688",
    x1: 113.814,
    y1: 46.2285,
    x2: 112.943,
    y2: 48.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3506_261688",
    x1: 63.464,
    y1: 29.181,
    x2: 65.9119,
    y2: 30.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3506_261688",
    x1: 158.974,
    y1: 77.7864,
    x2: 156.293,
    y2: 75.2618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387196,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3506_261688",
    x1: 147.568,
    y1: 76.4471,
    x2: 146.486,
    y2: 74.9926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3506_261688",
    x1: 119.086,
    y1: 32.6388,
    x2: 119.761,
    y2: 31.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458744,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3506_261688",
    x1: 119.563,
    y1: 112.479,
    x2: 115.67,
    y2: 110.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3506_261688",
    x1: 119.088,
    y1: 113.752,
    x2: 115.159,
    y2: 112.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3506_261688",
    x1: 116.819,
    y1: 116.464,
    x2: 45.0497,
    y2: 126.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3506_261688",
    x1: 117.001,
    y1: 111.361,
    x2: 51.1408,
    y2: 117.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3506_261688",
    x1: 72.5428,
    y1: 121.457,
    x2: 71.2553,
    y2: 127.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3506_261688",
    x1: 79.2607,
    y1: 112.562,
    x2: 79.3277,
    y2: 114.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3506_261688",
    x1: 61.4026,
    y1: 98.6501,
    x2: 65.5919,
    y2: 98.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3506_261688",
    x1: 61.2515,
    y1: 99.9995,
    x2: 65.4797,
    y2: 100.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3506_261688",
    x1: 58.9992,
    y1: 100.814,
    x2: 16.7033,
    y2: 42.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3506_261688",
    x1: 63.5872,
    y1: 98.5706,
    x2: 26.702,
    y2: 43.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3506_261688",
    x1: 33.7291,
    y1: 64.1164,
    x2: 27.827,
    y2: 65.8107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3506_261688",
    x1: 44.7399,
    y1: 65.8475,
    x2: 42.7442,
    y2: 66.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3506_261688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3677 13.4652) rotate(90) scale(11.9462 33.1524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#9AE7FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3506_261688",
    x1: 130.822,
    y1: 6.60702,
    x2: 120.102,
    y2: 30.8016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3506_261688",
    x1: 5.56926,
    y1: 0,
    x2: 5.56926,
    y2: 10.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421216,
    stopColor: "#C2E0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2C9FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotPic);
export default __webpack_public_path__ + "static/media/bot-pic.493252df16f5ad9cb321edaf66f64fa1.svg";
export { ForwardRef as ReactComponent };